import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { guestApi } from './guestApi';

function formatDetail(detail) {
  if (!detail) return 'PIN non valido';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || '').join(' ');
  return String(detail);
}

export function PinScreen({ token, brand, logo, onSuccess }) {
  const [pin, setPin] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [logoOk, setLogoOk] = useState(true);

  const submit = async (e) => {
    e.preventDefault();
    if (pin.length !== 4) { setErr('Inserisci le 4 cifre del PIN'); return; }
    setErr(''); setBusy(true);
    try {
      await guestApi.verify(token, pin);
      onSuccess();
    } catch (e2) {
      setErr(formatDetail(e2.response?.data?.detail));
      setPin('');
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-paelbi-bg px-4" data-testid="guest-pin-screen">
      <div className="w-full max-w-sm rounded-2xl border border-paelbi-line bg-white p-8 text-center shadow-card">
        {logo && logoOk
          ? <img src={logo} alt={brand} onError={() => setLogoOk(false)} className="mx-auto mb-4 h-16 w-16 rounded-lg object-contain" />
          : <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-paelbi-bg2"><Lock size={24} className="text-paelbi-brown" /></div>}
        <h1 className="font-display text-2xl text-paelbi-ink">{brand || 'Accesso ospiti'}</h1>
        <p className="mt-1 text-sm text-paelbi-ink/60">Inserisci il PIN fornito dalla struttura per accedere.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input
            data-testid="guest-pin-input"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={4}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            placeholder="••••"
            className="w-full rounded-xl border border-paelbi-line bg-paelbi-bg px-4 py-3 text-center text-3xl tracking-[0.6em] text-paelbi-ink outline-none focus:border-paelbi-brown"
          />
          {err && <p className="text-sm text-red-600" data-testid="guest-pin-error">{err}</p>}
          <button type="submit" disabled={busy}
            className="h-12 w-full rounded-btn bg-paelbi-brown font-semibold text-white transition-colors hover:bg-paelbi-brown-dark disabled:opacity-60"
            data-testid="guest-pin-submit">
            {busy ? 'Verifica...' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PinScreen;
